import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

const STORAGE_KEY = "app_lang";
const DEFAULT_LANG = "en";
const SUPPORTED_LANGS = ["en", "ar"];

@Injectable()
export class LanguageService {
  private currentLang = DEFAULT_LANG;

  constructor(private translate: TranslateService) {}

  init(): void {
    this.translate.addLangs(SUPPORTED_LANGS);
    this.translate.setDefaultLang(DEFAULT_LANG);
    const storedLang = this.getStoredLang();
    this.use(storedLang || DEFAULT_LANG, false);
  }

  use(lang: string, persist = true): void {
    const nextLang = this.normalizeLang(lang) || DEFAULT_LANG;
    if (this.currentLang === nextLang && this.translate.currentLang === nextLang) {
      return;
    }
    this.currentLang = nextLang;
    this.translate.use(nextLang);
    if (persist) {
      try {
        localStorage.setItem(STORAGE_KEY, nextLang);
      } catch (err) {
        // Ignore storage errors to avoid breaking language switching.
      }
    }
  }

  getCurrentLang(): string {
    return this.currentLang || this.translate.currentLang || DEFAULT_LANG;
  }

  private getStoredLang(): string | null {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (err) {
      return null;
    }
  }

  private normalizeLang(lang: string | null | undefined): string | null {
    if (!lang) {
      return null;
    }
    const normalized = lang.toLowerCase();
    return SUPPORTED_LANGS.includes(normalized) ? normalized : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/i18n/language.service.ts